import { Button } from "@mui/material";
import courseImage from "src/Common/CourseImage";

interface Courses {
    courseId: number;
    courseName: string;
    courseDescription: string;
    percentage: number;
    images: string;
    packageId: number;
    courseVideoCount: number;
    purchased: boolean;
    onServer: boolean;
}

interface MyCoursePackagesProps {
    courses: Courses[];
    courseStartLearning: (course: Courses) => void;
}

const MyCoursesDisplay: React.FC<MyCoursePackagesProps> = ({
    courses,
    courseStartLearning,
}) => {

    return (
        <div
            style={{
                width: "100%",
                background: "transparent",
            }}
        >

            <div
                className="myCoursesPackage"
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fill, minmax(290px, 1fr))",
                    gap: "24px",
                    width: "100%",
                }}
            >

                {courses.map((course) => {

                    const poster =
                        courseImage.find(
                            data =>
                                data.courseId ===
                                course.courseId
                        )?.posterLink;

                    const progress = Math.min(
                        Math.max(
                            Number(course.percentage) || 0,
                            0
                        ),
                        100
                    );

                    const isStarted =
                        progress > 0;

                    const isCompleted =
                        progress >= 100;

                    return (

                        <div
                            key={course.courseId}
                            style={{
                                position: "relative",
                                width: "100%",
                                minWidth: 0,

                                background:
                                    "linear-gradient(145deg, rgba(255,255,255,0.075), rgba(255,255,255,0.025))",

                                border:
                                    "1px solid rgba(245,180,95,0.18)",

                                borderRadius:
                                    "20px",

                                overflow: "hidden",

                                boxShadow:
                                    "0 15px 40px rgba(0,0,0,0.35)",

                                backdropFilter:
                                    "blur(12px)",

                                transition:
                                    "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
                            }}
                            onMouseEnter={(e) => {

                                e.currentTarget.style.transform =
                                    "translateY(-6px)";

                                e.currentTarget.style.boxShadow =
                                    "0 20px 45px rgba(245,180,95,0.14)";

                                e.currentTarget.style.borderColor =
                                    "rgba(245,180,95,0.45)";
                            }}
                            onMouseLeave={(e) => {

                                e.currentTarget.style.transform =
                                    "translateY(0)";

                                e.currentTarget.style.boxShadow =
                                    "0 15px 40px rgba(0,0,0,0.35)";

                                e.currentTarget.style.borderColor =
                                    "rgba(245,180,95,0.18)";
                            }}
                        >

                            {/* =================================================
                                FUTURISTIC TOP GLOW
                            ================================================== */}

                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: "15%",
                                    width: "70%",
                                    height: "2px",

                                    background:
                                        "linear-gradient(90deg, transparent, #f5b45f, transparent)",

                                    boxShadow:
                                        "0 0 15px rgba(245,180,95,0.8)",

                                    zIndex: 5,
                                }}
                            />


                            {/* =================================================
                                COURSE IMAGE
                            ================================================== */}

                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "190px",
                                    overflow: "hidden",
                                    background: "#080808",
                                }}
                            >

                                {poster ? (

                                    <img
                                        src={poster}
                                        alt={
                                            course.courseName ||
                                            course.images
                                        }
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",

                                            transition:
                                                "transform 0.5s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform =
                                                "scale(1.06)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform =
                                                "scale(1)";
                                        }}
                                    />

                                ) : (

                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#555",
                                            fontSize: "40px",
                                        }}
                                    >
                                        <i className="fa-solid fa-graduation-cap" />
                                    </div>

                                )}


                                {/* IMAGE OVERLAY */}

                                <div
                                    style={{
                                        position: "absolute",
                                        inset: 0,

                                        background:
                                            "linear-gradient(to bottom, rgba(0,0,0,0.05) 30%, rgba(0,0,0,0.9) 100%)",
                                    }}
                                />


                                {/* COURSE STATUS */}

                                <div
                                    style={{
                                        position: "absolute",
                                        top: "14px",
                                        right: "14px",

                                        padding:
                                            "6px 11px",

                                        borderRadius:
                                            "20px",

                                        background:
                                            "rgba(0,0,0,0.65)",

                                        border:
                                            "1px solid rgba(245,180,95,0.35)",

                                        backdropFilter:
                                            "blur(8px)",

                                        color:
                                            "#f5b45f",

                                        fontSize:
                                            "11px",

                                        fontWeight:
                                            700,

                                        letterSpacing:
                                            "0.5px",
                                    }}
                                >

                                    <i
                                        className={
                                            isCompleted
                                                ? "fa-solid fa-circle-check"
                                                : "fa-solid fa-bolt"
                                        }
                                        style={{
                                            marginRight:
                                                "5px",
                                        }}
                                    />

                                    {isCompleted
                                        ? "COMPLETED"
                                        : isStarted
                                            ? "IN PROGRESS"
                                            : "READY TO START"}

                                </div>


                                {/* COURSE NUMBER */}

                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "12px",
                                        left: "15px",

                                        width: "34px",
                                        height: "34px",

                                        borderRadius: "50%",

                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",

                                        background:
                                            "rgba(0,0,0,0.65)",

                                        border:
                                            "1px solid rgba(255,255,255,0.18)",

                                        color: "#f5b45f",

                                        fontSize: "13px",
                                    }}
                                >
                                    <i className="fa-solid fa-play" />
                                </div>

                            </div>


                            {/* =================================================
                                COURSE CONTENT
                            ================================================== */}

                            <div
                                style={{
                                    padding:
                                        "18px 18px 20px",
                                }}
                            >

                                {/* COURSE NAME */}

                                <h3
                                    style={{
                                        margin:
                                            "0 0 8px",

                                        color:
                                            "#ffffff",

                                        fontSize:
                                            "18px",

                                        fontWeight:
                                            700,

                                        lineHeight:
                                            "1.3",

                                        letterSpacing:
                                            "0.2px",

                                        display:
                                            "-webkit-box",

                                        WebkitLineClamp:
                                            2,

                                        WebkitBoxOrient:
                                            "vertical",

                                        overflow:
                                            "hidden",
                                    }}
                                >
                                    {course.courseName}
                                </h3>


                                {/* DESCRIPTION */}

                                <p
                                    style={{
                                        margin:
                                            "0 0 18px",

                                        color:
                                            "#8f8f8f",

                                        fontSize:
                                            "13px",

                                        lineHeight:
                                            "1.6",

                                        minHeight:
                                            "42px",

                                        display:
                                            "-webkit-box",

                                        WebkitLineClamp:
                                            2,

                                        WebkitBoxOrient:
                                            "vertical",

                                        overflow:
                                            "hidden",
                                    }}
                                >
                                    {course.courseDescription}
                                </p>


                                {/* =================================================
                                    PROGRESS HEADER
                                ================================================== */}

                                <div
                                    style={{
                                        display:
                                            "flex",

                                        justifyContent:
                                            "space-between",

                                        alignItems:
                                            "center",

                                        marginBottom:
                                            "8px",
                                    }}
                                >

                                    <div
                                        style={{
                                            display:
                                                "flex",

                                            alignItems:
                                                "center",

                                            gap:
                                                "7px",

                                            color:
                                                "#aaa",

                                            fontSize:
                                                "12px",
                                        }}
                                    >

                                        <i
                                            className="fa-solid fa-chart-line"
                                            style={{
                                                color:
                                                    "#f5b45f",
                                            }}
                                        />

                                        Learning Progress

                                    </div>


                                    <span
                                        style={{
                                            color:
                                                "#f5b45f",

                                            fontSize:
                                                "13px",

                                            fontWeight:
                                                700,
                                        }}
                                    >
                                        {progress}%
                                    </span>

                                </div>


                                {/* =================================================
                                    FUTURISTIC PROGRESS BAR
                                ================================================== */}

                                <div
                                    style={{
                                        position:
                                            "relative",

                                        width:
                                            "100%",

                                        height:
                                            "6px",

                                        background:
                                            "#252525",

                                        borderRadius:
                                            "10px",

                                        overflow:
                                            "hidden",

                                        marginBottom:
                                            "18px",
                                    }}
                                >

                                    <div
                                        style={{
                                            width:
                                                `${progress}%`,

                                            height:
                                                "100%",

                                            background:
                                                "linear-gradient(90deg, #b97828, #f5b45f, #ffe0a5)",

                                            borderRadius:
                                                "10px",

                                            boxShadow:
                                                "0 0 12px rgba(245,180,95,0.6)",

                                            transition:
                                                "width 0.5s ease",
                                        }}
                                    />

                                </div>


                                {/* =================================================
                                    COURSE INFO
                                ================================================== */}

                                <div
                                    style={{
                                        display:
                                            "flex",

                                        justifyContent:
                                            "space-between",

                                        alignItems:
                                            "center",

                                        marginBottom:
                                            "16px",

                                        padding:
                                            "9px 11px",

                                        borderRadius:
                                            "10px",

                                        background:
                                            "rgba(255,255,255,0.035)",

                                        border:
                                            "1px solid rgba(255,255,255,0.06)",
                                    }}
                                >

                                    <div
                                        style={{
                                            display:
                                                "flex",
                                            alignItems:
                                                "center",
                                            gap:
                                                "7px",
                                            color:
                                                "#888",
                                            fontSize:
                                                "11px",
                                        }}
                                    >

                                        <i
                                            className="fa-solid fa-video"
                                            style={{
                                                color:
                                                    "#f5b45f",
                                            }}
                                        />

                                        {course.courseVideoCount} Videos

                                    </div>


                                    <div
                                        style={{
                                            display:
                                                "flex",
                                            alignItems:
                                                "center",
                                            gap:
                                                "7px",
                                            color:
                                                "#888",
                                            fontSize:
                                                "11px",
                                        }}
                                    >

                                        <i
                                            className="fa-solid fa-shield-halved"
                                            style={{
                                                color:
                                                    "#f5b45f",
                                            }}
                                        />

                                        Enrolled

                                    </div>

                                </div>


                                {/* =================================================
                                    ACTION BUTTON
                                ================================================== */}

                                {course.courseVideoCount >
                                0 ? (

                                    <Button
                                        onClick={() =>
                                            courseStartLearning(
                                                course
                                            )
                                        }

                                        fullWidth

                                        style={{
                                            height:
                                                "45px",

                                            borderRadius:
                                                "12px",

                                            color:
                                                "#080808",

                                            background:
                                                "linear-gradient(135deg, #f5b45f, #ffd68e)",

                                            fontWeight:
                                                800,

                                            fontSize:
                                                "14px",

                                            textTransform:
                                                "none",

                                            letterSpacing:
                                                "0.2px",

                                            boxShadow:
                                                "0 7px 20px rgba(245,180,95,0.18)",

                                            transition:
                                                "all 0.25s ease",
                                        }}
                                        onMouseEnter={(e) => {

                                            e.currentTarget.style.transform =
                                                "translateY(-2px)";

                                            e.currentTarget.style.boxShadow =
                                                "0 10px 25px rgba(245,180,95,0.3)";
                                        }}
                                        onMouseLeave={(e) => {

                                            e.currentTarget.style.transform =
                                                "translateY(0)";

                                            e.currentTarget.style.boxShadow =
                                                "0 7px 20px rgba(245,180,95,0.18)";
                                        }}
                                    >

                                        <i
                                            className={
                                                isStarted
                                                    ? "fa-solid fa-play"
                                                    : "fa-solid fa-rocket"
                                            }

                                            style={{
                                                marginRight:
                                                    "9px",
                                            }}
                                        />

                                        {isStarted
                                            ? `Resume Learning`
                                            : "Start Learning"}

                                        <i
                                            className="fa-solid fa-arrow-right"
                                            style={{
                                                marginLeft:
                                                    "auto",
                                            }}
                                        />

                                    </Button>

                                ) : (

                                    <Button
                                        disabled
                                        fullWidth

                                        style={{
                                            height:
                                                "45px",

                                            borderRadius:
                                                "12px",

                                            color:
                                                "#777",

                                            background:
                                                "#1c1c1c",

                                            border:
                                                "1px solid #292929",

                                            fontWeight:
                                                700,

                                            fontSize:
                                                "14px",

                                            textTransform:
                                                "none",
                                        }}
                                    >

                                        <i
                                            className="fa-solid fa-clock"
                                            style={{
                                                marginRight:
                                                    "8px",
                                            }}
                                        />

                                        Coming Soon

                                    </Button>

                                )}

                            </div>

                        </div>
                    );
                })}

            </div>

        </div>
    );
};

export default MyCoursesDisplay;